._optionSelector_3bfqm_1 {
  pointer-events: all; }
  ._optionSelector__item_3bfqm_3:not(:last-child) {
    padding-bottom: 12px; }
